import { render, staticRenderFns } from "./DemoConfigs.vue?vue&type=template&id=15d54cb2"
import script from "./DemoConfigs.vue?vue&type=script&lang=ts"
export * from "./DemoConfigs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports